import { useSelector } from "react-redux";
import { brandingConfig } from "../branding/brandingConfig";
import { useMemo } from "react";

/**
 * Use Brand Hook Attributes Hook
 * 1. Use the brand logo for the header
 * 2. If not present use the default checkventory
 */
export default () => {
    const { userOrganisations, typesList } = useSelector((state) => state);
    const { organisationThemes } = typesList;
    const { item } = userOrganisations;

    /** Check for 
    1. Check  item of userOrganisations is present
    2. Check organisationThemes is loaded
    */
    const currentTheme = useMemo(() => {
        return (
            item &&
            organisationThemes &&
            organisationThemes.data.find(
                (orgList) => orgList.organisation.id == item.id
            )
        );
    }, [item, organisationThemes]);
    return brandingConfig(currentTheme);
};
